import React, { useContext, useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_URL_agentEmail, API_URL_ticket } from "constants/api";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "context/AuthContext";

const ModalChangeOwner = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);

  const [email, setEmail] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const { datauser } = useContext(AuthContext);

  const handleEmailChange = async (value) => {
    const inputValue = value;

    try {
      const response = await axios.get(
        `${API_URL_agentEmail}?query=${inputValue}`
      );
      setSuggestions(response.data.suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleclose = () => {
    setSuggestions([]);
    setEmail("");
    onClose();
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("User Email must be a valid email")
        .required("User Email is required"),
    }),
    onSubmit: (values) => {
      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "PUT",
        data: { email: values.email, by_user: datauser.id },
        url: API_URL_ticket + item + "/",
      })
        .then((response) => {
          toast.success("Ticket Change Owner Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          callback();
          handleclose();
        })
        .catch((error) => {
          console.log(error);
          toast.warning(error.response?.data.message, {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    },
  });

  useEffect(() => {
    handleEmailChange(formik.values.email);
  }, [formik.values.email]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => handleclose()}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex justify-between">
                        <Dialog.Title
                          as="h3"
                          className="text-2xl font-semibold leading-6 text-gray-900"
                        >
                          Change Owner for ticket
                        </Dialog.Title>
                        <button
                          type="button"
                          className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                          onClick={() => handleclose()}
                        >
                          X
                        </button>
                      </div>

                      <hr className="my-2" />
                      <div className="px-6 py-1">
                        <label htmlFor="link" className="block mb-1">
                          Select User Email
                          <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          className="w-full p-2 border border-gray-300 rounded-md mb-2"
                          placeholder="Enter email User"
                          id="custom-email-field"
                          name="email"
                          autoComplete="off"
                          aria-autocomplete="off"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                        />
                        <ul className="list-none max-h-60 overflow-y-auto">
                          {suggestions.map((suggest, index) => (
                            <li
                              className={`hover:bg-gray-300 bg-gray-100 py-0.5 my-1 cursor-pointer `}
                              key={index}
                              onClick={() =>
                                formik.setFieldValue("email", suggest)
                              }
                            >
                              {suggest}
                            </li>
                          ))}
                        </ul>

                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red-500 dark:text-red-300 text-xs">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={() => handleclose()}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalChangeOwner;
